// document.querySelector('a[href="#shopify-section-template--23586165129514__custom_liquid_4aUKfR"]').addEventListener('click', function(event) {
//     event.preventDefault();

//     const section = document.querySelector('#shopify-section-template--23586165129514__custom_liquid_4aUKfR');

//     // Add padding to the section before scrolling
//     section.style.paddingTop = '400px';

//     // Scroll to the section with smooth scroll
//     section.scrollIntoView({ behavior: 'smooth', block: 'start' });

//     // Reset padding after scrolling, or you can leave it if you want the padding to remain
//     setTimeout(function() {
//         section.style.paddingTop = ''; // Reset padding if you don't want it to stay
//     }, 1000); // Adjust timeout as needed for scroll completion
// });

document.querySelectorAll('.wrg-header .sub-menu a').forEach(link => {
    // Replace "Men ", "Men's ", "Women ", and "Women's " from the beginning of the text
    link.textContent = link.textContent.replace(/^Men\s|^Men's\s|^Women\s|^Women's\s/, '');
});



document.addEventListener('DOMContentLoaded', function () {
    const mainButton = document.querySelector('#ProductSubmitButton-template--18882137358592__main');
    const paymentButton = document.querySelector('.shopify-payment-button__button');

    if (mainButton && paymentButton) {
        const togglePaymentButton = () => {
            if (mainButton.disabled) {
                paymentButton.disabled = true;
                paymentButton.setAttribute('aria-disabled', 'true');
            } else {
                paymentButton.disabled = false;
                paymentButton.setAttribute('aria-disabled', 'false');
            }
        };

        // Initialize on page load
        togglePaymentButton();

        // Monitor changes to the main button
        const observer = new MutationObserver(togglePaymentButton);
        observer.observe(mainButton, { attributes: true, attributeFilter: ['disabled'] });
    }
});




document.getElementById('menuToggle').addEventListener('click', function() {
            document.documentElement.classList.toggle('no-height'); // Add class to <html>
        });


function initializeMenu() {
    const screenWidth = window.innerWidth;

    if (screenWidth >= 769) {
        // Get all menu list items (li) in the main menu
        const menuItems = document.querySelectorAll('.main-menu > li');

        menuItems.forEach(item => {
            const menuLinks = item.querySelectorAll('.sub-menu a');
            const productItems = item.querySelectorAll('.all-shirt-products > div');
            const menuHolder = item.querySelector('.sub-menu-main-holder');

            // Function to deactivate all product items within the current menu item
            function deactivateItems() {
                productItems.forEach(productItem => productItem.classList.remove('active'));
            }

            // Function to activate the first product item within the current menu item
            function activateFirstItem() {
                const firstItem = productItems[0];
                if (firstItem) {
                    firstItem.classList.add('active');
                }
            }

            // Add hover event listener to each menu link within the current menu item
            menuLinks.forEach(link => {
                link.addEventListener('mouseover', function(event) {
                    event.preventDefault(); // Prevent default link behavior

                    // Deactivate all items within this menu item
                    deactivateItems();

                    // Get the ID of the item to be activated
                    const targetId = link.getAttribute('data-id');

                    // Find the corresponding product item within this menu item and activate it
                    const targetItem = item.querySelector(targetId);
                    if (targetItem) {
                        targetItem.classList.add('active');
                    }
                });
            });

            // Check if menuHolder exists before adding mouseleave event
            if (menuHolder) {
                menuHolder.addEventListener('mouseleave', function() {
                    // Deactivate all items within this menu item
                    deactivateItems();

                    // Activate the first product item within this menu item
                    activateFirstItem();
                });
            }

            // Activate the first product item by default within this menu item
            activateFirstItem();
        });
    }
}

// Run the function on page load
initializeMenu();

// Run the function on window resize
window.addEventListener('resize', initializeMenu);



// SAME--HEIGHT--JQUERY
window.onload = function() {
    // Check if viewport width is above 767 pixels
    if (window.innerWidth > 767) {
        // Equalize heights of divs with class 'equal-height-div'
        equalizeHeights('.item1 a');
    }
};

function equalizeHeights(className) {
    // Get all elements with the specified class name
    var divs = document.querySelectorAll(className);

    // Initialize variable to hold maximum height
    var maxHeight = 0;

    // Loop through each div to find the maximum height
    divs.forEach(function(div) {
        var divHeight = div.clientHeight;
        maxHeight = Math.max(maxHeight, divHeight);
    });

    // Set the height of all divs to the maximum height
    divs.forEach(function(div) {
        div.style.height = maxHeight + 'px';
    });
}

// Collection Page Filters
document.querySelector('#sort_by').addEventListener('change', function(e) {
  var collection_url = new URL(window.location.href);
  collection_url.searchParams.set('sort_by', e.currentTarget.value);

  window.location = collection_url.href;
});


